import axios from '../axios'

/* 
 * 上传
 */

/**
 * 单张图片上传
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
 export const uploadImg = (service, data) => {
    return axios({
        url: '/' + service + '/api/common/uploadImg',
        method: 'post',
        data
    })
}
/**
 * 省市区域
 * @returns
 */
export const selectProvince = (params) => {
    return axios({
        url: '/api/province/selectProvince',
        method: 'get',
        params
    })
}

export const selectCity = (params) => {
    return axios({
        url: '/api/province/selectCity',
        method: 'get',
        params
    })
}

export const selectArea = (params) => {
    return axios({
        url: '/api/province/selectArea',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/common/upload.js